import * as r from 'ramda';

export function category(state, categoryId) {
    const category = r.path(
        ['productConfigurator', 'categories', categoryId],
        state
    );
    const selectedVariant = r.path(
        ['productConfigurator', 'selectedVariant'],
        state
    );
    const configRestrictions = r.path(
        ['productConfigurator', 'configRestrictions', selectedVariant],
        state
    );

    const newProps = {
        maxConfigs: Math.min.apply(
            undefined,
            r.append(
                category.maxConfigs,
                r.map(
                    r.prop('maxConfigs'),
                    r.filter(
                        r.propEq('categoryIds', [categoryId]),
                        configRestrictions
                    )
                )
            )
        ),
        minConfigs: Math.max.apply(
            undefined,
            r.append(
                category.minConfigs,
                r.map(
                    r.prop('minConfigs'),
                    r.filter(
                        r.propEq('categoryIds', [categoryId]),
                        configRestrictions
                    )
                )
            )
        ),
    };

    return r.mergeRight(category, newProps);
}

export function isCategoryValid(state, categoryId) {
    const category = r.path(
        ['productConfigurator', 'categories', categoryId],
        state
    );

    return categoryConfigsCount(state, categoryId) >= category.minConfigs;
}

export function categoryConfigsCount(state, categoryId) {
    const productConfigIds = r.pathOr(
        [],
        ['productConfigurator', 'categories', categoryId, 'productConfigIds'],
        state
    );
    const counts = r.map(
        (productConfigId) =>
            r.path(
                [
                    'productConfigurator',
                    'productConfigs',
                    productConfigId,
                    'count',
                ],
                state
            ),
        productConfigIds
    );

    return r.sum(counts);
}

export function categoryShouldHaveExactly1Config(category) {
    return (
        category.minConfigs === 1 && category.minConfigs === category.maxConfigs
    );
}

export function shouldNotifyAboutExceededLimit(state) {
    const selectedVariant = r.path(
        ['productConfigurator', 'selectedVariant'],
        state
    );
    if (
        selectedVariant !==
        r.path(['productConfigurator', 'unrestrictedVariant'], state)
    ) {
        return false;
    }

    return areVariantRestrictionsViolated(state, selectedVariant);
}

export function areVariantRestrictionsViolated(state, variant) {
    const configRestrictions = r.path(
        ['productConfigurator', 'configRestrictions', variant],
        state
    );

    return r.any((restriction) => {
        const configsInCategories = r.sum(
            r.map(
                (categoryId) => categoryConfigsCount(state, categoryId),
                restriction.categoryIds
            )
        );

        return configsInCategories > restriction.maxConfigs;
    }, configRestrictions);
}

export function shouldAskToUpgradeVariant(state) {
    const selectedVariant = r.path(
        ['productConfigurator', 'selectedVariant'],
        state
    );
    if (
        selectedVariant ===
        r.path(['productConfigurator', 'unrestrictedVariant'], state)
    ) {
        return false;
    }

    return areVariantRestrictionsViolated(state, selectedVariant);
}

export function downgradedVariant(state) {
    const selectedVariant = r.path(
        ['productConfigurator', 'selectedVariant'],
        state
    );
    if (
        selectedVariant !==
        r.path(['productConfigurator', 'unrestrictedVariant'], state)
    ) {
        return selectedVariant;
    }

    const possibleVariants = r.path(['productConfigurator', 'variants'], state);
    const variantAdepts = r.pipe(
        r.dissoc(selectedVariant),
        r.keys,
        r.map(Number)
    )(possibleVariants);

    return r.defaultTo(
        selectedVariant,
        r.find(
            (variant) => !areVariantRestrictionsViolated(state, variant),
            variantAdepts
        )
    );
}
